/* eslint-disable max-classes-per-file */

export class OpenAccessOrdersFlags {
    static isCancellableOnEditState(order) {
        return !order.existing;
    }
}

export class OnlineOpenOrdersFlags {
    static isCancellableOnEditState(order) {
        return !order.existing;
    }
}
